var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_20828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47811 6.05811C1.55756 6.05811 0 7.61557 0 9.53752C0 11.4581 1.55756 13.0142 3.47811 13.0142C5.39867 13.0142 6.95623 11.4581 6.95623 9.53752C6.95623 7.61557 5.39867 6.05811 3.47811 6.05811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47811 16.5225C1.55756 16.5225 0 18.0786 0 20.0006C0 21.9211 1.55756 23.4786 3.47811 23.4786C5.39867 23.4786 6.95623 21.9211 6.95623 20.0006C6.95623 18.0786 5.39867 16.5225 3.47811 16.5225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47811 26.9854C1.55756 26.9854 0 28.5428 0 30.4634C0 32.3839 1.55756 33.9415 3.47811 33.9415C5.39867 33.9415 6.95623 32.3839 6.95623 30.4634C6.95623 28.5428 5.39867 26.9854 3.47811 26.9854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3847 6.9209H12.6438C11.1995 6.9209 10.0283 8.09207 10.0283 9.53763C10.0283 10.982 11.1994 12.1531 12.6438 12.1531H37.3847C38.8289 12.1531 40.0001 10.982 40.0001 9.53763C40.0001 8.09207 38.8289 6.9209 37.3847 6.9209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3847 17.3838H12.6438C11.1995 17.3838 10.0283 18.5549 10.0283 20.0005C10.0283 21.4449 11.1994 22.616 12.6438 22.616H37.3847C38.8289 22.616 40.0001 21.4449 40.0001 20.0005C40.0001 18.5549 38.8289 17.3838 37.3847 17.3838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3847 27.8477H12.6438C11.1995 27.8477 10.0283 29.0187 10.0283 30.4631C10.0283 31.9074 11.1994 33.0784 12.6438 33.0784H37.3847C38.8289 33.0784 40.0001 31.9074 40.0001 30.4631C40.0001 29.0187 38.8289 27.8477 37.3847 27.8477Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_20828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.2edb0751d7578698305ffed2a3f02e1c.svg";
export { ForwardRef as ReactComponent };